import React from 'react';
import * as Atoms from '../../atoms';
import * as Molecules from '../../molecules';
import { localI18n } from '../../../i18n';
const uxCopy = {
  header: localI18n._("Document Settings")
};
const DocumentSettings = ({
  hasExtraBottomPadding
}) => React.createElement(React.Fragment, null, React.createElement(Atoms.Dumb.SectionHeader, null, uxCopy.header), React.createElement(Atoms.Dumb.RowGrid, {
  hasExtraBottomPadding: hasExtraBottomPadding
}, React.createElement(Molecules.Smart.TogglePublic, null), React.createElement(Molecules.Smart.ToggleReusable, null)));
export default DocumentSettings;